import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imServerMessage', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/server-message/server-message.html'),
        controller: 'ServerMessageController',
        controllerAs: 'ServerMessageCtrl',
        bindings: {
            message: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/server-message/server-message.component.ts